// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"42a1aed0","977":"8ff2e8de"}[chunkId] + ".chunk.js";
};